import "antd/dist/antd.css";
import React, { useMemo } from "react";
import Layout from "./components/shared/Layout";
import { ChannelContext } from "./context/channel";
import Loading from "./pages/Loading";
import Page403 from "./pages/Page403/403";
import Page404 from "./pages/Page404/404";
import Routes from "./Routes";
import { ThemeProvider } from "styled-components";
import theme from "./theme/theme";

function App() {
  const { data, loading, errorPage } = React.useContext(ChannelContext)

  const ViewMemo = useMemo(() => {
    if (loading) {
      return (<Loading />)
    }

    // if (errorPage !== "OK") {
    //   return errorPage === '404' ? <Page404 /> : <Page403 />;
    // }

    return (
      <ThemeProvider theme={{ ...theme, colors: { ...theme.colors, ...data.colors } }}>
        <Layout>
          <Routes />
        </Layout>
      </ThemeProvider>
    );
  }, [data.colors, loading, errorPage]);

  return ViewMemo;
}

export default App;
